import script from "./Migration.vue?vue&type=script&setup=true&lang=js"
export * from "./Migration.vue?vue&type=script&setup=true&lang=js"

import "./Migration.vue?vue&type=style&index=0&id=e4affe02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4affe02"]])

export default __exports__